export default __webpack_public_path__ + "static/media/ic-test.90c80c08.svg";